import { ModalLayout } from "#layouts";
import React from "react";
import { ClipLoader } from "react-spinners";

export default function CustomModal({
  children,
  onSubmit,
  open,
  onClose,
  loading,
  title,
  actionButtonTitle,
  isCancelButtonRequired,
  customClass,
  actionBtnNotRequired,
}) {
  return (
    <ModalLayout open={open} onClose={onClose} customClass={customClass}>
      <div className="common-box-body">
        <h2>{title}</h2>
        {children}
        <div className="common-modal-btns">
          {isCancelButtonRequired && (
            <button class="secondary-btn" onClick={onClose}>
              Cancel
            </button>
          )}

          {actionBtnNotRequired ? null : (
            <button class="btn primary-btn" onClick={() => onSubmit()}>
              {loading ? (
                <ClipLoader size={17} color="#fff" />
              ) : (
                actionButtonTitle
              )}
            </button>
          )}
        </div>
      </div>
    </ModalLayout>
  );
}
